<template>
  <b-badge
    qa="status-badge"
    class="state-badge"
    pill
    :class="statusClass"
  >
    {{ status.name }}
  </b-badge>
</template>

<script>

export default {
    name: 'CommonStatusBadge',
    props: {
        status: { type: Object, required: true }
    },
    computed: {
        statusClass() {
            return this.status.class
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
    min-width: 85px;
    max-width: 120px;
    font-size: 11px;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
